export enum SortOrderEnum {
    ASC = 'asc',
    DESC = 'desc'
}

export enum SortOrderCapitalEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}